import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { auth } from './modules/auth.js'
import { s3 } from './modules/s3.js'
import { courseManager } from './modules/course-manager.js'
import { coursePlayer } from './modules/course-player.js'
import theme from './modules/theme.js';

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		auth,
		s3,
		courseManager,
		coursePlayer,
		theme
	},
	plugins: [createPersistedState()],
})
